

















import {
  computed,
  defineNuxtComponent,
  ref,
  vue3Model,
  watch
} from '~/utils/nuxt3-migration'
import CFormGroup from '~/components/shared/configurable/form/CFormGroup.vue'
import CRadioButtonGroup from '~/components/shared/configurable/button/CRadioButtonGroup.vue'
import { useI18n } from '~/compositions/i18n'
import { useRoute } from '@nuxtjs/composition-api'

export default defineNuxtComponent({
  model: vue3Model,
  components: {
    CFormGroup,
    CRadioButtonGroup
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n()
    const route = useRoute()

    const facet = ref(props.modelValue)
    const selectedValue = ref(
      route.value.query.finance === 'leasing' ? 'leasing' : ''
    )

    watch(
      () => props.modelValue,
      (newValue: any) => {
        facet.value = {
          ...facet.value,
          ...newValue
        }

        selectedValue.value =
          route.value.query.finance === 'leasing' ? 'leasing' : ''
      }
    )

    const options = computed(() => [
      {
        value: '',
        label: t('buy::agora')
      },
      {
        value: 'leasing',
        label: 'Leasing',
        variant: 'leasing'
      }
    ])

    function handleChange(newValue: string) {
      selectedValue.value = newValue

      emit('update:modelValue', {
        name: 'finance',
        value: newValue
      })
    }

    return {
      selectedValue,
      facet,
      options,
      handleChange
    }
  }
})
